import React, { useContext } from "react";
import { motion } from "framer-motion";
import topSongsData from "../data/topSongs.json";
import { CurrentPlaylistContext, TOP_SONGS_PLAYLIST_ID } from "../contexts/CurrentPlaylistContext";
import { PlayerContext } from "../contexts/PlayerContext";

const TopSongs = ({ onBack }) => {
  // eslint-disable-next-line no-unused-vars
  const { currentPlaylist, currentVideoIndex, setCurrentPlaylist, setVideosDirectly, setCurrentVideoIndex, activePlaylist, activeVideoIndex, startPlaying } =
    useContext(CurrentPlaylistContext);
  const { isPlaying } = useContext(PlayerContext);

  const handlePlay = (index) => {
    setCurrentPlaylist(TOP_SONGS_PLAYLIST_ID);
    setVideosDirectly(topSongsData);
    setCurrentVideoIndex(index);
    startPlaying(TOP_SONGS_PLAYLIST_ID, index, topSongsData);
  };

  const formatViews = (views) => {
    if (views >= 1000000) return `${(views / 1000000).toFixed(1)}M`;
    if (views >= 1000) return `${(views / 1000).toFixed(0)}k`;
    return views.toString();
  };

  return (
    <div className="top-songs-container">
      {onBack && (
        <button className="btn-top50-back" onClick={onBack}>
          <i className="fa-solid fa-arrow-left"></i> Zpět
        </button>
      )}
      {topSongsData.map((song, index) => (
        <motion.div
          key={song.video_id}
          className={`top-song-tile${activePlaylist === TOP_SONGS_PLAYLIST_ID && activeVideoIndex === index ? " active" : ""}`}
          onClick={() => handlePlay(index)}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: index * 0.02 }}
        >
          <div className="top-song-rank">
            {activePlaylist === TOP_SONGS_PLAYLIST_ID && activeVideoIndex === index && isPlaying ? (
              <div className="music-wave music-wave-dark">
                <span></span>
                <span></span>
                <span></span>
              </div>
            ) : (
              song.rank
            )}
          </div>
          <div className="top-song-info">
            <div className="top-song-title">{song.title}</div>
            <div className="top-song-artist">{song.artist}</div>
          </div>
          <div className="top-song-views">
            <i className="fa-solid fa-play"></i>
            {formatViews(song.views)}
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default TopSongs;
